import styled from '@emotion/styled'
import React from 'react'
import { breakpoint, calcRem, fonts } from '../../../../__styling'
import { RibbonOptions } from '../../helpers/BreachWallTypes'
import {
    PackageOptions,
    PackageThemeProps,
} from '../BreachWallContent/BreachWallContent'
import { StyledSubscriptionRadioInput as SubscriptionRadioInput } from '../SubscriptionPriceDisplay/SubscriptionPriceDisplay.styled'

export const StyledSubscriptionPackageContainer = styled(
    'div',
)<PackageThemeProps>(({ packageOptions }) => [
    {
        display: 'flex',
        flexDirection: 'column',
        padding: calcRem(24, 24, 16, 24),
        alignItems: 'center',
        gap: calcRem(16),
        flex: '1 0 0',
        alignSelf: 'stretch',
        position: 'relative',

        borderRadius: calcRem(8),
        background: '#FFF',
        boxShadow: `6px 6px 26px 0 rgba(0,0,0, 0.21)`,

        maxWidth: calcRem(344),

        [breakpoint('xs')]: {
            width: calcRem(344),
        },
    },
    // If it's recommended, we apply the following styles to make it stand out
    packageOptions.isRecommended === true && {
        border: `2px solid #043DE2`,

        // Create a ribbon effect on the before which says "Best Value"
        '&::before': {
            content: `'Best Value!'`,
            position: 'absolute',
            top: calcRem(-20),

            height: calcRem(40),
            padding: calcRem(0, 16),
            alignContent: 'center',

            background: '#043DE2',
            fontFamily: fonts.thewest.sansSerif,
            fontSize: calcRem(16),
            fontWeight: 600,
            lineHeight: calcRem(18),
            color: '#FFF',

            borderRadius: calcRem(99),
            boxShadow: `0 4px 20px 0 rgba(0,0,0, 0.11)`,
        },
    },
    // If the columns are to be positioned in a grid layout, we apply the following styles to enable that
    packageOptions.gridColumnPosition && {
        gridRow: packageOptions.gridColumnPosition.mobile,

        [breakpoint('xs')]: {
            gridColumn: packageOptions.gridColumnPosition.desktop,
            gridRow: 1,
        },
    },
])

export const StyledSubscriptionContentContainer = styled('div')({
    display: 'flex',
    paddingTop: calcRem(8),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: calcRem(16),
    flex: `1 0 0`,
    alignSelf: 'stretch',
})

export const StyledSubscriptionTitleContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: calcRem(8),
    alignSelf: 'stretch',
    height: calcRem(95),
})

export const StyledSubscriptionSubHeading = styled('p')({
    margin: 0,
    fontSize: calcRem(16),
    fontFamily: fonts.thewest.sansSerif,
    fontWeight: 400,
    lineHeight: calcRem(18),
    color: '#2B2D2E',
})

export const StyledSubscriptionHeading = styled('p')({
    margin: 0,
    fontSize: calcRem(28),
    fontFamily: fonts.thewest.serif,
    fontWeight: 700,
    lineHeight: calcRem(36),
    color: '#2B2D2E',
})

export const StyledSubscriptionPricingAndBenefitsContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: calcRem(16),
    flex: '1 0 0',
    alignSelf: 'stretch',
})

export const StyledSubscriptionPriceContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: calcRem(6),
    alignSelf: 'stretch',
})

export const StyledSubscriptionInnerPriceContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: calcRem(16),
    alignSelf: 'stretch',
})

export const StyledSubscriptionPriceTextContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: calcRem(8),
})

export const StyledSubscriptionPrice = styled('p')<{
    packageOptions: PackageOptions
}>(({ packageOptions }) => [
    {
        margin: 0,
        fontSize: calcRem(32),
        fontFamily: fonts.thewest.sansSerifCond,
        fontWeight: 600,
        color: '#2B2D2E',
        lineHeight: calcRem(32),
        textTransform: 'uppercase',
    },
    packageOptions.isRecommended === true && {
        color: '#043DE2',
        fontSize: calcRem(42),
        fontWeight: 700,
    },
])
export const StyledSubscriptionSubPriceText = styled('p')({
    margin: 0,

    color: '#2B2D2E',
    fontFamily: fonts.thewest.sansSerif,
    fontSize: calcRem(16),
    fontWeight: 400,
    lineHeight: calcRem(18),
})
export const StyledSubscriptionQualifierText = styled('p')({
    margin: 0,

    color: '#535556',
    fontFamily: fonts.thewest.sansSerif,
    fontSize: calcRem(12),
    fontWeight: 400,
    lineHeight: calcRem(16),
})

export const StyledRibbon = styled('div')<{ ribbonOption: RibbonOptions }>(
    ({ ribbonOption }) => [
        {
            display: 'flex',
            padding: calcRem(8, 16),
            alignItems: 'center',
            gap: calcRem(4),

            borderRadius: calcRem(72),
            background: 'rgba(4, 61, 226, 0.06)',

            span: {
                color: '#043DE2',
                margin: 0,
                fontFamily: fonts.thewest.sansSerif,
                fontSize: calcRem(16),
                fontWeight: 500,
                lineHeight: calcRem(18),
            },
        },
        ribbonOption === 'freeDeliveryBluePill' && {
            padding: calcRem(0, 16, 0, 0),
            gap: calcRem(8),
            background: '#043DE2',
            alignSelf: 'end',

            span: {
                color: '#FFF',
                fontWeight: 600,
            },
        },
    ],
)

export const StyledBenefitsContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: calcRem(8),
    alignSelf: 'stretch',
})

export const StyledBenefit = styled('img')({
    width: calcRem(20),
    height: calcRem(20),

    // backgroundImage: `url('${BENEFIT_TICK_ICON}')`,
})

export const StyledBenefitRowContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: calcRem(8),
    alignSelf: 'stretch',
})

export const StyledBenefitText = styled('p')<{ isBenefitAccessible: boolean }>(
    ({ isBenefitAccessible }) => [
        {
            color: '#2B2D2E',
            margin: 0,

            fontFamily: fonts.thewest.sansSerif,
            fontSize: calcRem(16),
            fontWeight: 400,
            lineHeight: calcRem(18),
        },
        isBenefitAccessible === false && {
            color: 'rgba(43, 45, 46, 0.30)',
        },
    ],
)

export const StyledRadioButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: calcRem(8),
    alignSelf: 'stretch',
    padding: calcRem(12),

    borderRadius: calcRem(2),
    background: 'rgba(0, 0, 0, 0.03)',
})

export const StyledRadioRowContainer = styled('label')({
    display: 'flex',
    alignItems: 'center',
    gap: calcRem(8),
})

export const StyledRadioRowText = styled('p')({
    color: '#2B2D2E',
    margin: 0,

    fontFamily: fonts.thewest.sansSerif,
    fontSize: calcRem(16),
    fontWeight: 400,
    lineHeight: calcRem(20),
})

export const StyledSubscriptionButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: calcRem(8),
    alignSelf: 'stretch',
})

export const StyledSubscriptionRadioInput = styled(SubscriptionRadioInput)({
    background: 'white',
})

export const StyledSubscribeButton = styled('button')<PackageThemeProps>(
    ({ buttonStyle }) => [
        // -- Base Styles (Applied to all packages)
        {
            fontSize: calcRem(18),
            lineHeight: calcRem(20),
            color: '#043DE2',
            padding: calcRem(12, 24),
            fontWeight: 500,
            width: '100%',
            border: 'none',
            borderRadius: calcRem(2),
            cursor: 'pointer',

            '&:hover, &:focus': {
                opacity: 0.8,
            },
        },
        // -- Button Style Variations
        buttonStyle === 'solid-blue' && {
            background: '#043DE2',
            color: '#FFF',
        },
        buttonStyle === 'light-blue' && {
            background: 'rgba(4, 61, 226, 0.06)',
            border: '1px solid #043DE2',
        },
    ],
)

export const StyledSwgButton = styled('button')(() => ({
    cursor: 'pointer',
    maxWidth: '100%',
    width: '100%',
    minHeight: calcRem(44),
    padding: calcRem(12, 24),
    borderRadius: calcRem(2),
    border: `1px solid #043DE2`,

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: calcRem(8),
    background: '#FFF',

    // Hide the original SwG
    '&::after': {
        backgroundImage: 'none',
        width: 0,
        height: 0,
        margin: 0,
    },
    '&:hover, &:focus': {
        background: '#F5F5F5',
    },
    span: {
        color: '#043DE2',
        fontFamily: fonts.thewest.sansSerif,
        fontSize: calcRem(18),
        fontWeight: 500,
        lineHeight: calcRem(20),
    },
}))

export const StyledCancellationMessage = styled('p')(() => [
    {
        margin: 0,
        fontSize: calcRem(12),
        fontFamily: fonts.thewest.sansSerif,
        fontWeight: 400,
        lineHeight: calcRem(16),
        color: '#2B2D2E',
    },
])

export const IconGoogle = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6 12.2273C21.6 11.5182 21.5364 10.8364 21.4182 10.1819H12V14.0501H17.3818C17.15 15.3001 16.4455 16.3592 15.3864 17.0682V19.5773H18.6182C20.5091 17.8364 21.6 15.2728 21.6 12.2273Z"
            fill="#4285F4"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0001 21.9999C14.7001 21.9999 16.9637 21.1044 18.6183 19.5772L15.3864 17.0681C14.491 17.6681 13.3455 18.0226 12.0001 18.0226C9.39554 18.0226 7.19099 16.2635 6.40463 13.8999H3.06372V16.4908C4.70918 19.759 8.09099 21.9999 12.0001 21.9999Z"
            fill="#34A853"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.40455 13.8999C6.20455 13.2999 6.09091 12.659 6.09091 11.9999C6.09091 11.3409 6.20455 10.6999 6.40455 10.0999V7.50903H3.06364C2.38636 8.85903 2 10.3863 2 11.9999C2 13.6136 2.38636 15.1409 3.06364 16.4909L6.40455 13.8999Z"
            fill="#FBBC05"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0001 5.97727C13.4683 5.97727 14.7864 6.48182 15.8228 7.47273L18.691 4.60455C16.9592 2.99091 14.6955 2 12.0001 2C8.09099 2 4.70918 4.24091 3.06372 7.50909L6.40463 10.1C7.19099 7.73636 9.39554 5.97727 12.0001 5.97727Z"
            fill="#EA4335"
        />
    </svg>
)
